var map = {
	"./projectImages/bhalurent.png": 9329,
	"./projectImages/botkraft.png": 3823,
	"./projectImages/bunkmyjiit.png": 2800,
	"./projectImages/bytesweep.png": 204,
	"./projectImages/bytesweep2.png": 2004,
	"./projectImages/oak.png": 4753,
	"./vercel.png": 4385
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 715;